function checkAndFixB2G1Cart() {
  const data = document.querySelector('script#cart_data');
  if (!data) return;

  const cartData = JSON.parse(data.innerHTML);

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const variantMap = {};

      for (const item of cart.items) {
        const collectionItem = cartData.find(i => i.id === item.id);
        const collections = collectionItem?.collections?.split(',') || [];

        if (!collections.includes(window.BOGO_COLLECTION_HANDLE)) continue;

        const variantId = item.variant_id;
        const isFree = item.properties && item.properties.free_b2g1;

        if (!variantMap[variantId]) {
          variantMap[variantId] = { normal: 0, free: 0 };
        }

        if (isFree) {
          variantMap[variantId].free += item.quantity;
        } else {
          variantMap[variantId].normal += item.quantity;
        }
      }

      const itemsToAdd = [];

      for (const [variantId, { normal, free }] of Object.entries(variantMap)) {
        // ✅ B2G1 logic — 1 free for every 2 paid (not total)
        const eligibleFree = Math.floor(normal / 2);
        const missingFree = eligibleFree - free;

        if (missingFree > 0) {
          itemsToAdd.push({
            id: Number(variantId),
            quantity: missingFree,
            properties: {
              free_b2g1: true
            }
          });
        }
      }

      if (itemsToAdd.length > 0) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        }).then(res => {
          if (res.ok) {
            return res.json().then(() => {
              window.location.reload();
            });
          } else {
            console.error('Failed to add items:', res.statusText);
          }
        });
      }else {
        window.location.reload();
      }
    })
    .catch(console.error);
}

if(!window.disabled_bogo) {
    document.addEventListener('cart:updated', () => {
        checkAndFixB2G1Cart();
    });
}

